<template>
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
    <!-- Finding Header -->
    <div class="flex items-start justify-between mb-4">
      <div class="flex-1">
        <div class="flex items-center gap-3 mb-2">
          <RiskLevelBadge :level="finding.severity" />
        </div>
        <div v-if="finding.categoryName" class="text-sm text-gray-500 dark:text-gray-400 mb-3">
          {{ finding.categoryName }}
        </div>
      </div>
    </div>

    <!-- Finding Content -->
    <div class="space-y-4">
      <!-- Main Finding -->
      <div>
        <p class="text-gray-900 dark:text-white font-medium leading-relaxed">{{ finding.finding }}</p>
      </div>

      <!-- Evidence -->
      <div v-if="finding.evidence">
        <div class="bg-gray-50 dark:bg-gray-900 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
          <h4 class="font-medium text-gray-900 dark:text-white mb-2 text-sm">Evidence</h4>
          <p class="text-sm text-gray-700 dark:text-gray-300">{{ finding.evidence }}</p>
        </div>
      </div>

      <!-- Recommendation -->
      <div v-if="finding.recommendation">
        <div class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 border border-blue-200 dark:border-blue-800">
          <h4 class="font-medium text-blue-900 dark:text-blue-300 mb-2 text-sm flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Recommendation
          </h4>
          <p class="text-sm text-blue-800 dark:text-blue-300">{{ finding.recommendation }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import RiskLevelBadge from './RiskLevelBadge.vue'

defineProps({
  finding: {
    type: Object,
    required: true
  }
})
</script>